import { render, staticRenderFns } from "./CatalogCompensationForm.vue?vue&type=template&id=23e067a0&"
import script from "./CatalogCompensationForm.vue?vue&type=script&lang=ts&"
export * from "./CatalogCompensationForm.vue?vue&type=script&lang=ts&"
import style0 from "@/assets/css/components/forms/zero-waste-form.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports